export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_MASTER_DATE = 'UPDATE_MASTER_DATA';
export const UPDATE_LOADER_STATE = 'UPDATE_LOADER_STATE';